module.exports = __webpack_public_path__ + "img/appstore.ecca8642.png";